const ACTION_LABELS: Record<string, string> = {
  'operations.config.update': 'Configuração da operação',
  'operations.create': 'Operação criada',
  'devices.add': 'Dispositivo criado',
  'devices.delete': 'Dispositivo removido',
  'equipaments.save': 'Equipamentos salvos',
  'equipaments.remote_block': 'Bloqueio remoto',
  'equipaments.replace_tid': 'TID substituído',
  'users_machine.save': 'Usuários máquina salvos',
  'firmware.upload': 'Firmware enviado',
  'firmware.assign': 'Firmware atribuído',
  'checklist.assign': 'Checklist atribuído',
  'checklist_config.save': 'Configuração de checklist',
  'geofence.update': 'Cerca virtual atualizada',
  'geofence.delete': 'Cerca virtual removida',
  'geofence.sync': 'Cercas virtuais sincronizadas',
};

export function actionLabel(action?: string | null): string {
  if (!action) return 'Ação não informada';
  return ACTION_LABELS[action] || action;
}

export function formatAuditTimestamp(timestamp?: string | null): string {
  if (!timestamp) return 'Sem horário';
  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) return timestamp;
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}

function summarizeNestedValue(value: any): string {
  if (value && typeof value === 'object' && typeof value.count === 'number') {
    return `${value.count} itens`;
  }
  if (Array.isArray(value)) return `${value.length} itens`;
  if (value && typeof value === 'object') return 'objeto';
  if (value === null || value === undefined || value === '') return '—';
  return String(value);
}

export function summarizeAuditValue(value: any): string {
  if (Array.isArray(value)) return `${value.length} itens`;
  if (!value || typeof value !== 'object') return summarizeNestedValue(value);

  const entries = Object.entries(value).slice(0, 4);
  if (entries.length === 0) return 'Sem dados';
  return entries.map(([key, item]) => `${key}: ${summarizeNestedValue(item)}`).join(' • ');
}
